import React, { CSSProperties, memo } from "react";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { PLBillTextAnimation, PLBillTextPrimitive } from "@swiggy-private/cart-types";
import { PL_BILL_PRIMITIVES_TEST_IDS } from "@swiggy-private/cart-test-ids";

import TextShimmer from "../text-shimmer/TextShimmer";
import { DEFAULT_TEXT_COLOR, DEFAULT_TEXT_VARIANT } from "./constants";
import { FreeTextLayout, ShimmerTextWrapper, ShimmerTextContent } from "./BillText.style";

interface BillTextProps {
    item: PLBillTextPrimitive;
}

const BillText = ({ item }: BillTextProps) => {
    const { text, animation, properties } = item;
    const style = properties?.style as CSSProperties | undefined;
    const { background, ...restStyle } = (style ?? {}) as CSSProperties;
    const hasFreeTextLayout = Boolean(background);
    const innerStyle = hasFreeTextLayout ? restStyle : style;
    const appliedInnerStyle = innerStyle && Object.keys(innerStyle).length > 0 ? innerStyle : undefined;
    const hasShimmer = animation === PLBillTextAnimation.SHIMMER_LEFT_TO_RIGHT;
    const labelStyle = hasShimmer || hasFreeTextLayout ? undefined : appliedInnerStyle;
    const wrapperStyle = hasFreeTextLayout ? undefined : appliedInnerStyle;

    const renderLabel = () => (
        <Text
            as="span"
            data-testid={PL_BILL_PRIMITIVES_TEST_IDS.TEXT}
            style={labelStyle}
            variant={properties?.dls?.textVariant || DEFAULT_TEXT_VARIANT}
            color={properties?.dls?.textColor || DEFAULT_TEXT_COLOR}
        >
            {text}
        </Text>
    );

    const renderContent = () =>
        hasShimmer ? (
            <ShimmerTextWrapper style={wrapperStyle}>
                <TextShimmer />
                <ShimmerTextContent>{renderLabel()}</ShimmerTextContent>
            </ShimmerTextWrapper>
        ) : (
            renderLabel()
        );

    if (!hasFreeTextLayout) {
        return renderContent();
    }

    return (
        <FreeTextLayout $background={background as string} style={appliedInnerStyle}>
            {renderContent()}
        </FreeTextLayout>
    );
};

export default memo(BillText);
